export const KYC_SOURCE_OF_FUNDS_EVENTS = {
  SELECT_SOURCE_OF_FUNDS: 'select_source_of_funds',
} as const;
